import { toastFailed, toastSuccess } from 'utils/toast'
import {
  SET_IS_START_HUB_DETAIL,
  SET_IS_FAILED_HUB_DETAIL,
  SET_IS_SUCCESS_HUB_DETAIL,
  SET_IS_NEED_TO_RELOAD_HUB_DETAIL,
  SET_PAGINATION_DATA_HUB_DETAIL,
  SET_SELECT_PRODUCT_DATA_HUB_DETAIL,
  SET_IS_FAILED_HUB_DETAIL_HISTORY,
  SET_IS_SUCCESS_HUB_DETAIL_HISTORY,
  SET_PAGINATION_DATA_HUB_DETAIL_HISTORY,
  SET_IS_START_INVENTORY_LOCATION,
  SET_IS_FAILED_INVENTORY_LOCATION,
  SET_IS_SUCCESS_INVENTORY_LOCATION,
  SET_PAGINATION_INVENTORY_LOCATION,
  SET_UPDATE_INVENTORY_LOCATION_FAILED,
  SET_SAVE_INVENTORY_LOCATION_FAILED,
  SET_SAVE_INVENTORY_LOCATION_START,
  SET_IS_START_INVENTORY_STATUS,
  SET_IS_START_INVENTORY_NOTE_BY_STATUS,
  SET_IS_FAILED_INVENTORY_NOTE_BY_STATUS,
  SET_IS_FAILED_INVENTORY_STATUS,
  SET_IS_SUCCESS_INVENTORY_STATUS,
  SET_IS_SUCCESS_INVENTORY_NOTE_BY_STATUS,
  SET_PAGINATION_INVENTORY_STATUS,
  SET_PAGINATION_INVENTORY_NOTE_BY_STATUS,
  SET_IS_START_INVENTORY_SAVE,
  SET_IS_FAILED_INVENTORY_SAVE,
  SET_IS_SUCCESS_INVENTORY_SAVE,
  SET_MODAL_INFORMATION,
  SET_INVENTORY_NOTE,
  RESET_STATE_HUB_DETAIL,
} from 'storeContext/actionsType/hubDetail'

import {
  getHubDetailList_HD,
  getHubHistory,
  getProductDetail_HD,
  saveInventoryLocation,
  updateInventoryLocation,
  wimsUpdateInventoryLocation,
  getInventoryStatus,
} from 'utils/apiList/hubDetail'
import { getInventoryStatusNotes } from 'features/Product/services/product'
import { postInventoryDetailTransfer } from 'features/Product/services/inventoryDetail'
import { getProductInventoriesDetailsAPI } from 'features/Product/services/inventory'
import { dateFormat } from '@astronautsid/wpe-utils'
import { callErrorMsg } from 'helpers/errorMsg'
import dayjs from 'dayjs'

export const transferLocationStart = () => {
  return {
    type: SET_SAVE_INVENTORY_LOCATION_START,
  }
}

export const inventoryLocationStart = () => {
  return {
    type: SET_IS_START_INVENTORY_LOCATION,
  }
}

export const inventorySaveStart = () => {
  return {
    type: SET_IS_START_INVENTORY_SAVE,
  }
}

export const inventorySaveStop = () => {
  return {
    type: SET_IS_FAILED_INVENTORY_SAVE,
  }
}

export const inventorySaveSuccess = () => {
  return {
    type: SET_IS_SUCCESS_INVENTORY_SAVE,
  }
}

export const inventoryNoteByStatusStart = () => {
  return {
    type: SET_IS_START_INVENTORY_NOTE_BY_STATUS,
  }
}

export const inventoryNoteByStatusStop = () => {
  return {
    type: SET_IS_FAILED_INVENTORY_NOTE_BY_STATUS,
  }
}

export const inventoryStatusStart = () => {
  return {
    type: SET_IS_START_INVENTORY_STATUS,
  }
}

export const inventoryStatusStop = () => {
  return {
    type: SET_IS_FAILED_INVENTORY_STATUS,
  }
}

export const inventoryLocationStop = () => {
  return {
    type: SET_IS_FAILED_INVENTORY_LOCATION,
  }
}

export const saveProductDetailStop = () => {
  return {
    type: SET_UPDATE_INVENTORY_LOCATION_FAILED,
  }
}

export const updateProductDetailStop = () => {
  return {
    type: SET_SAVE_INVENTORY_LOCATION_FAILED,
  }
}

export const hubDetailStart = () => {
  return {
    type: SET_IS_START_HUB_DETAIL,
  }
}

export const hubDetailStop = () => {
  return {
    type: SET_IS_FAILED_HUB_DETAIL,
  }
}

export const hubHistoryStop = () => {
  return {
    type: SET_IS_FAILED_HUB_DETAIL_HISTORY,
  }
}

export const getHubDetailData = (data) => {
  return {
    type: SET_IS_SUCCESS_HUB_DETAIL,
    payload: data,
  }
}

export const getHubHistoryData = (data) => {
  return {
    type: SET_IS_SUCCESS_HUB_DETAIL_HISTORY,
    payload: data,
  }
}

export const getInventoryLocationData = (data) => {
  return {
    type: SET_IS_SUCCESS_INVENTORY_LOCATION,
    payload: data,
  }
}

export const getInventoryStatusData = (data) => {
  return {
    type: SET_IS_SUCCESS_INVENTORY_STATUS,
    payload: data,
  }
}

export const getInventoryNoteByStatusData = (data) => {
  return {
    type: SET_IS_SUCCESS_INVENTORY_NOTE_BY_STATUS,
    payload: data,
  }
}

export const setPagination = (data) => {
  return {
    type: SET_PAGINATION_DATA_HUB_DETAIL,
    payload: data,
  }
}

export const setPaginationHistory = (data) => {
  return {
    type: SET_PAGINATION_DATA_HUB_DETAIL_HISTORY,
    payload: data,
  }
}

export const setPaginationInventoryLocation = (data) => {
  return {
    type: SET_PAGINATION_INVENTORY_LOCATION,
    payload: data,
  }
}

export const setPaginationInventoryStatus = (data) => {
  return {
    type: SET_PAGINATION_INVENTORY_STATUS,
    payload: data,
  }
}

export const setPaginationInventoryNoteStatus = (data) => {
  return {
    type: SET_PAGINATION_INVENTORY_NOTE_BY_STATUS,
    payload: data,
  }
}

export const reloadHubDetail = () => {
  return {
    type: SET_IS_NEED_TO_RELOAD_HUB_DETAIL,
  }
}

export const selectProductData = (data) => {
  return {
    type: SET_SELECT_PRODUCT_DATA_HUB_DETAIL,
    payload: data,
  }
}

export const setModalInformation = (data) => ({
  type: SET_MODAL_INFORMATION,
  payload: data,
})

export const setInventoryNote = (data) => {
  return {
    type: SET_INVENTORY_NOTE,
    payload: data,
  }
}

export const resetStateHubDetail = (data) => {
  return {
    type: RESET_STATE_HUB_DETAIL,
    payload: data,
  }
}

export const getListOfHubDetail =
  (query = false, localState = {}) =>
  (dispatch, getState) => {
    dispatch(hubDetailStart())
    //const { selectedProduct } = getState().stateHubDetail;

    return getHubDetailList_HD(localState.product_id, query)
      .then(({ data }) => {
        dispatch(getHubDetailData(data))

        const pagination = {
          currentItem: data.numberOfElements,
          currentPage: data.number,
          pageSize: data.size,
          totalData: data.totalElements,
          totalPage: data.totalPages,
        }
        dispatch(setPagination(pagination))
        dispatch(hubDetailStop())
      })
      .catch(() => {
        toastFailed('terjadi masalah, coba beberapa saat lagi')

        dispatch(hubDetailStop())
      })
  }

export const getListHubHistory = (payload, query) => (dispatch) => {
  dispatch(hubDetailStart())
  return getHubHistory(payload, query)
    .then(({ data }) => {
      dispatch(getHubHistoryData(data.data, query))
      dispatch(setPaginationHistory(data.pagination))
    })
    .catch((err) => {
      toastFailed('terjadi masalah, coba beberapa saat lagi')
      dispatch(hubHistoryStop())
    })
}

const formatEpochToDateString = (epoch) =>
  dateFormat({ date: new Date(Number(epoch)), format: 'YYYY-MM-DD', locale: 'id' })

/** Map old-style params (payload + search) into new inventories detail query params */
const mapToProductInventoriesDetailsParams = (payload, search) => {
  const { location_id, product_id, pageIndex } = payload
  const { date_range: { status, createdDateFrom, createdDateTo } = {} } = search || {}

  return {
    location_id: Number(location_id),
    product_ids: Number(product_id),
    have_stock: true,
    'pagination.page_index': Number(pageIndex) + 1,
    'pagination.page_size': search?.pageSize || 20,
    ...(status && createdDateFrom && createdDateTo
      ? {
          expiry_date_from: formatEpochToDateString(createdDateFrom),
          expiry_date_to: formatEpochToDateString(createdDateTo),
        }
      : {}),
  }
}

/** Map new inventories detail response item into the old flat content item shape */
const mapInventoryDetailItemToOldContentItem = (item) => ({
  product_detail_id: item.id,
  stock: item.stock,
  reserved_stock: item.reserved_stock,
  external_reserved_stock: item.external_reserved_stock,
  expiry_date: item.expiry_date,
  qr_code: item.qr_code,
  is_active: item.is_active,
  created_at: item.created_at,
  updated_at: item.updated_at,
  created_by: item.created_by,
  updated_by: item.updated_by,
  product_id: item.product?.id,
  product_name: item.product?.name,
  product_sku_number: item.product?.sku_number,
  location_id: item.location?.id,
  location_name: item.location?.name,
  location_type: item.location?.type,
  rack_id: item.rack?.id,
  rack_name: item.rack?.rack_name,
  status_id: item.status,
  status_name: item.status_name,
  status_notes_id: item.status_notes_id,
  status_notes_name: item.status_note_name,
  package_id: item.package_id?.id,
  package_label: item.package_id?.package_label,
  package_id_enable: item.package_id_enable,
  updated_expiry_date: item.updatable_expiry_date,
  required_expiry_date: item.require_expiry_date,
  enable_transfer: item.enable_transfer,
  rack_editable: item.rack_editable,
  maxAdjustQty: item.max_adjust_qty,
  lost_period_from: item.lost_period_from,
  lost_period_to: item.lost_period_to,
})

export const getListInventoryLocation = (payload, query) => (dispatch) => {
  dispatch(hubDetailStart())
  const params = mapToProductInventoriesDetailsParams(payload, query)

  return getProductInventoriesDetailsAPI(params)
    .then(({ data }) => {
      const listData = data?.data || []
      const content = listData.map(mapInventoryDetailItemToOldContentItem)

      /**
       * this only contain first and last for pagination
       * first/last are derived since the new API does not provide them
       */
      const first = Number(payload.pageIndex) === 0
      const last = listData.length < params['pagination.page_size']

      dispatch(getInventoryLocationData({ data: { content, first, last } }))
      dispatch(setPaginationInventoryLocation({ first, last }))
      dispatch(hubDetailStop())
    })
    .catch(() => {
      toastFailed('terjadi masalah, coba beberapa saat lagi')
      dispatch(hubDetailStop())
    })
}

export const saveProductDetail = (payload, callbackSuccess) => (dispatch) => {
  dispatch(inventorySaveStart())
  return saveInventoryLocation(payload)
    .then(() => {
      toastSuccess(`Product detail berhasil di tambahkan`)
      callbackSuccess()
      dispatch(inventorySaveSuccess())
    })
    .catch((error) => {
      callErrorMsg(error)
      dispatch(inventorySaveStop())
    })
}

export const updateProductDetail = (payload, id, callbackSuccess, callbackError) => (dispatch) => {
  dispatch(transferLocationStart())
  return updateInventoryLocation(payload, id)
    .then(({ data }) => {
      toastSuccess(`Product detail berhasil di ubah`)
      callbackSuccess()
    })
    .catch((error) => {
      callbackError()
      callErrorMsg(error)
      dispatch(updateProductDetailStop())
    })
}

export const actUpdateProductDetail =
  (id, payload, callbackSuccess, callbackError) => (dispatch) => {
    dispatch(transferLocationStart())
    const mappedPayload = {
      rack_id: payload.rackId,
      active: payload.isActive,
      ...(payload.stock !== undefined ? { stock: payload.stock } : {}),
      ...(payload.statusId !== undefined ? { status: payload.statusId } : {}),
      ...(payload.statusNotesId !== undefined ? { status_note: payload.statusNotesId } : {}),
      ...(payload.expiryDate !== undefined ? { expiry_date: payload.expiryDate } : {}),
      ...(payload.isDeleteExpiryDate !== undefined
        ? { is_delete_expiry_date: payload.isDeleteExpiryDate }
        : {}),
    }
    return wimsUpdateInventoryLocation(id, mappedPayload)
      .then(() => {
        toastSuccess(`Product detail berhasil di ubah`)
        callbackSuccess()
      })
      .catch((error) => {
        callbackError()
        callErrorMsg(error)
        dispatch(updateProductDetailStop())
      })
  }

export const transferProductDetail = (payload, id, callbackSuccess) => (dispatch) => {
  dispatch(transferLocationStart())

  const mappedPayload = {
    inventory_detail_id: id,
    stock: payload.stock,
    status_id: payload.statusId,
    ...(payload.statusNotesId !== undefined ? { status_note_id: payload.statusNotesId } : {}),
    ...(payload.rackId !== undefined ? { rack_id: payload.rackId } : {}),
    ...(payload.packageId !== undefined ? { package_id: payload.packageId } : {}),

    ...(payload.expiryDate !== undefined && payload.expiryDate !== null
      ? { expiry_date: dayjs(payload.expiryDate).format('YYYY-MM-DD') }
      : {}),
  }

  return postInventoryDetailTransfer(mappedPayload)
    .then(({ data }) => {
      toastSuccess(`Product detail berhasil di transfer`)
      callbackSuccess()
    })
    .catch((error) => {
      callErrorMsg(error)

      dispatch(updateProductDetailStop())
    })
}

export const getProductDataById = (id) => (dispatch) => {
  dispatch(hubDetailStart())

  return getProductDetail_HD(id)
    .then(({ data }) => {
      selectProductData(data)
      dispatch(hubDetailStop())
    })
    .catch(() => {
      toastFailed('terjadi masalah, coba beberapa saat lagi')
      dispatch(hubDetailStop())
    })
}

export const getInventoryStatusAction = () => (dispatch) => {
  dispatch(inventoryStatusStart())
  return getInventoryStatus()
    .then(({ data }) => {
      dispatch(getInventoryStatusData(data))

      const listStatusId = data.data.status.map((statusItem) => statusItem.id)
      dispatch(getListOfStatusNotes(listStatusId))

      /**
       * this only contain first and last for pagination
       */
      const pagination = {
        first: data.first,
        last: data.last,
      }
      dispatch(setPaginationInventoryStatus(pagination))
    })
    .catch(() => {
      toastFailed('terjadi masalah dalam mendapatkan inventory status')
      dispatch(inventoryStatusStop())
    })
}

export const getInventoryNoteByStatusAction = (statusId) => async (dispatch) => {
  dispatch(inventoryNoteByStatusStart())

  try {
    const { data } = await getInventoryStatusNotes({
      page_size: 100,
      page_index: 1,
      inventory_status_id: statusId,
      exclusion_preset: 0,
    })
    dispatch(getInventoryNoteByStatusData(data.data))
  } catch (error) {
    callErrorMsg(error)
  } finally {
    dispatch(inventoryNoteByStatusStop())
  }
}

export const getListOfStatusNotes = (listStatusId) => async (dispatch) => {
  if (!Array.isArray(listStatusId) || listStatusId.length === 0) return
  try {
    const results = await Promise.all(
      listStatusId.map((id) =>
        getInventoryStatusNotes({
          page_size: 100,
          page_index: 1,
          inventory_status_id: id,
          exclusion_preset: 0,
        }).then((res) => res.data.data),
      ),
    )

    const notesMap = {}
    results.forEach((data, index) => {
      notesMap[listStatusId[index]] = data
    })

    dispatch(setInventoryNote(notesMap))
  } catch (err) {
    callErrorMsg(err)
  }
}

export const actResetStateHubDetail = (data) => (dispatch) => {
  dispatch(resetStateHubDetail())
}
